import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/constants";
import Reveal from "@/components/Reveal";

export default function ServicesPage() {
    return (
        <div data-testid="services-page" className="container-padded section-spacing">
            <div className="max-w-3xl">
                <div className="overline mb-4">Services</div>
                <h1 className="font-serif text-5xl md:text-6xl text-ink leading-[1.05]">From a single shelf to a full home interior.</h1>
                <p className="text-stone-muted mt-5 text-lg">Six core specialisations, one workshop. Everything is designed, built, finished and installed by our own team — never sub-contracted.</p>
            </div>

            <div className="mt-16 space-y-20 md:space-y-28">
                {SERVICES.map((s, i) => (
                    <Reveal key={s.slug}>
                        <article
                            data-testid={`service-${s.slug}`}
                            className={`grid md:grid-cols-12 gap-8 md:gap-14 items-center ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`}
                        >
                            <div className="md:col-span-7 overflow-hidden">
                                <div className="aspect-[5/3] overflow-hidden">
                                    <img src={s.image} alt={s.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                                </div>
                            </div>
                            <div className="md:col-span-5">
                                <div className="overline mb-3">0{i + 1} / 0{SERVICES.length}</div>
                                <h2 className="font-serif text-4xl md:text-5xl text-ink leading-tight">{s.title}</h2>
                                <p className="text-stone-muted text-base md:text-lg mt-5 leading-relaxed">{s.body}</p>
                                <Link to="/contact#quote" className="mt-8 inline-flex items-center gap-2 border-b border-walnut text-walnut pb-1 hover:text-walnut-light hover:border-walnut-light transition-colors text-sm tracking-wide">
                                    Discuss this project <ArrowRight size={16} />
                                </Link>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    );
}
